export const DropdownIcon = (): JSX.Element => (
	<svg
		width="64px"
		height="64px"
		viewBox="0 0 48 48"
		enableBackground="new 0 0 48 48"
		id="Layer_3"
		version="1.1"
		xmlSpace="preserve"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		fill="#000000"
	>
		<g id="bg" strokeWidth="0"></g>
		<g id="tracer" strokeLinecap="round" strokeLinejoin="round"></g>
		<g id="icon">
			<g>
				<rect fill="#000000" height="4" width="16" x="8.979" y="22"></rect>{' '}
				<rect fill="#000000" height="4" width="16" x="8.979" y="29"></rect>{' '}
				<rect fill="#000000" height="4" width="16" x="8.979" y="36"></rect>{' '}
				<path
					d="M31.979,0h-30v14.167V18v30h30V18h14.043V0H31.979z M27.979,44h-22V18h22V44z M27.979,14h-22V4h22V14z M37,11.422L33.086,6.62h7.83L37,11.422z"
					fill="#000000"
				></path>
			</g>
		</g>
	</svg>
)
